import { convertDateToEpochUTC } from "../../../../helper/DateConverters";

export const defaultFormValues = {
  date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
  project: null,
  name: [],
  site: null,
  surveySiteDescription: null,
  surveySiteDescriptionComment: null,
  purposeOfEntry: null,
  preEntryChecks: [
    {
      label: "Oxygen Deficiency",
      value: null,
      name: "oxygenDeficiency",
      controlMeasure: [
        {
          label: "Gas Detection in Place",
          value: null,
          name: "gasDetectionInPlace-1",
        },
      ],
    },
    {
      label: "Hazardous Gas Identification",
      value: null,
      name: "hazardousGasIdentification",
      controlMeasure: [
        {
          label: "Gas Detection in Place",
          value: null,
          name: "gasDetectionInPlace-2",
        },
      ],
    },
    {
      label: "Working presence of identified gas",
      value: null,
      name: "workingPresenceOfIdentifiedGas",
      controlMeasure: [
        {
          label: "Escape Set in place",
          value: null,
          name: "escapeSetInPlace",
        },
        {
          label: "Gas Monitor in place",
          value: null,
          name: "gasMonitorInPlace",
        },
        {
          label: "Rescue measures in place (Tripod, Winch and Harness)",
          value: null,
          name: "rescueMeasures",
        },
      ],
    },
    {
      label: "Access/ Egress (ladder etc)",
      value: null,
      name: "accessEgress",
      controlMeasure: [
        {
          label: "Existing Access Ladder in Place",
          value: null,
          name: "existingAccessLadderInPlace",
        },
        {
          label: "Use of Amelio Ladder",
          value: null,
          name: "useOfAmelioLadder",
        },
        {
          label: "Tripod Access",
          value: null,
          name: "tripodAccess",
        },
        {
          label: "Other:",
          value: null,
          name: "otherAccessMethods",
        },
      ],
    },
    {
      label: "Emergency Equipment",
      value: null,
      name: "emergencyEquipment",
      controlMeasure: [
        {
          label: "Fire Extinguisher available at works area",
          value: null,
          name: "fireExtinguisherAvailable",
        },
        {
          label: "First Aid Equipment Available at works area",
          value: null,
          name: "firstAidEquipmentAvailable",
        },
        {
          label: "Nearest A&E Department Confirmed",
          value: null,
          name: "nearestAEDepartmentConfirmed",
        },
      ],
    },
    {
      label: "All entrants Have training in Confined Spaces",
      value: null,
      name: "confinedSpacesTraining",
      controlMeasure: [
        {
          label:
            "Note other control measures to be used on separate page and attach",
          value: null,
          name: "otherControlMeasures",
        },
      ],
    },
  ],
  safetyEssentialEquipmentCheck: [
    {
      label: "Tripod In Place and In Date",
      value: null,
      name: "tripodInPlace",
    },
    {
      label: "Winch and Harness in Place and in Date",
      value: null,
      name: "winchAndHarnessInPlace",
    },
    {
      label: "Gas Monitors in Place and In Date",
      value: null,
      name: "gasMonitorsInPlace",
    },
    {
      label: "Sufficient Escape Set in Place",
      value: null,
      name: "sufficientEscapeSetInPlace",
    },
  ],
  entrantTopmans: {
    approvalOfPermit: [],
    permitClosure: [],
  },
  permitClosureReason: null,
  commentsIfAny: null,
  permitStartDateAndTime: null,
  permitEndDateAndTime: null,
};
